import { SeawardException } from '@ch-types/SeawardExceptions';
import { IArgumentType } from '@ch-types/Exception';

/**
 * Base exception for all Network Printing exceptions.
 */
export class NetworkPrintingException extends SeawardException {
    constructor(args: IArgumentType) {
        super(args);
        this.model = 'NetworkPrintingException';
    }

    /**
     * Static `deserialize` method to the Constructor so that SeawardCrossFrameObjectTranslator can use it to
     * deserialize the exception.
     *
     * @param obj - Containing message and other data.
     */
    public deserialize(obj): NetworkPrintingException {
        return new NetworkPrintingException({
            message: obj.message,
        });
    }
}

/**
 * Exception thrown when invalid printer IP address is provided.
 */
export class InvalidPrinterIPException extends NetworkPrintingException {
    constructor(args: IArgumentType) {
        super(args);
        this.model = 'InvalidPrinterIPException';
    }

    /**
     * Static `deserialize` method to the Constructor so that SeawardCrossFrameObjectTranslator can use it to
     * deserialize the exception.
     *
     * @param obj - Containing message and other data.
     */
    public deserialize(obj): InvalidPrinterIPException {
        return new InvalidPrinterIPException({
            message: obj.message,
        });
    }
}

/**
 * Exception thrown when ZPL data is missing or invalid.
 */
export class MissingZplDataException extends NetworkPrintingException {
    /* istanbul ignore next */
    constructor(args: IArgumentType) {
        super(args);
        this.model = 'MissingZplDataException';
    }

    /**
     * Static `deserialize` method to the Constructor so that SeawardCrossFrameObjectTranslator can use it to
     * deserialize the exception.
     *
     * @param obj - Containing message and other data.
     */
    public deserialize(obj): MissingZplDataException {
        return new MissingZplDataException({
            message: obj.message,
        });
    }
}

/**
 * Exception thrown when invalid port number is provided.
 */
export class InvalidPortException extends NetworkPrintingException {
    constructor(args: IArgumentType) {
        super(args);
        this.model = 'InvalidPortException';
    }

    /**
     * Static `deserialize` method to the Constructor so that SeawardCrossFrameObjectTranslator can use it to
     * deserialize the exception.
     *
     * @param obj - Containing message and other data.
     */
    public deserialize(obj): InvalidPortException {
        return new InvalidPortException({
            message: obj.message,
        });
    }
}

/**
 * Exception thrown when network connection fails.
 */
export class NetworkPrintingConnectionException extends NetworkPrintingException {
    constructor(args: IArgumentType) {
        super(args);
        this.model = 'NetworkPrintingConnectionException';
    }

    /**
     * Static `deserialize` method to the Constructor so that SeawardCrossFrameObjectTranslator can use it to
     * deserialize the exception.
     *
     * @param obj - Containing message and other data.
     */
    public deserialize(obj): NetworkPrintingConnectionException {
        return new NetworkPrintingConnectionException({
            message: obj.message,
        });
    }
}

/**
 * Exception thrown when the network printing operation times out.
 */
export class NetworkPrintingTimeoutException extends NetworkPrintingException {
    constructor(args: IArgumentType) {
        super(args);
        this.model = 'NetworkPrintingTimeoutException';
    }

    /**
     * Static `deserialize` method to the Constructor so that SeawardCrossFrameObjectTranslator can use it to
     * deserialize the exception.
     *
     * @param obj - Containing message and other data.
     */
    public deserialize(obj): NetworkPrintingTimeoutException {
        return new NetworkPrintingTimeoutException({
            message: obj.message,
        });
    }
}

/**
 * Exception thrown when an unknown error occurs during network printing.
 */
export class NetworkPrintingUnknownException extends NetworkPrintingException {
    constructor(args: IArgumentType) {
        super(args);
        this.model = 'NetworkPrintingUnknownException';
    }

    /**
     * Static `deserialize` method to the Constructor so that SeawardCrossFrameObjectTranslator can use it to
     * deserialize the exception.
     *
     * @param obj - Containing message and other data.
     */
    public deserialize(obj): NetworkPrintingUnknownException {
        return new NetworkPrintingUnknownException({
            message: obj.message,
        });
    }
}
